import styled from "vue3-styled-components";

export const Container = styled.div`
  position: relative;
  width: 100%;
  height: 100vh;
  display: flex;
`;

export const LeftSection = styled.div`
  width: 50%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
`;

export const RightSection = styled.div`
  width: 50%;
  height: 100%;
  background: url('./login.png') no-repeat center center;
  background-size: cover;
`;

export const LoginWrapper = styled.div`
  width: 500px;
  padding: 0 60px;
`;

export const HeaderContainer = styled.div`
  width: 450px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  margin-bottom: 40px;
`;

export const LogoContainer = styled.div`
  img {
    width: 100px;
    height: auto;
  }
`;

export const WelcomeTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 20px;
`;

export const WelcomeText = styled.div`
  font-size: 32px;
  font-weight: bold;
`;

export const SubWelcomeText = styled.div`
  font-size: 20px;
  margin-top: 5px;
  color: #666;
`;

export const FormContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const InputContainer = styled.div`
  width: 80%;
  margin: 0 auto;
`;

export const Form = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Input = styled.input`
  width: 100%;
  height: 45px;
  margin-bottom: 15px;
  padding: 0 15px;
  border: 2px solid #BDBDBD;
  border-radius: 5px;
  font-size: 16px;
  &:focus {
    outline: none;
    border-color: #0031E5;
  }
`;

export const SubmitButton = styled.button`
  width: 434px;
  height: 45px;
  background-color: #0031E5;
  color: white;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  margin-top: 20px;
  &:hover {
    background-color: #0052cc;
  }
`;

export const KakaoButton = styled.button`
  width: 434px;
  height: 45px;
  background-color: #FEE500;
  color: #000000;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  
  &:hover {
    background-color: #FDD800;
  }
`;
